import PropTypes from 'prop-types';
/* eslint-disable import/no-unresolved */
import { Swiper, SwiperSlide } from 'swiper/react';
import BlogPostCard from 'sealink/react-components/blog-post-card';
import EventCard from 'sealink/react-components/event-card';
import ExperienceCard from 'sealink/react-components/experience-card';

/* eslint-enable import/no-unresolved */

const RelatedEntriesCarousel = ({ entries, externalProducts }) => {
  const entryType = entries[0].type;
  const onlyOneEntry = entries.length === 1;
  const slidesPerView = entryType === 'blog' ? 2 : 3;

  let cardType;
  switch (entryType) {
    case 'blog':
      cardType = BlogPostCard;
      break;
    case 'events':
      cardType = EventCard;
      break;
    default:
      cardType = ExperienceCard;
      break;
  }

  const renderEntries = () =>
    entries.map((entry, index) => (
      // eslint-disable-next-line react/no-array-index-key
      <SwiperSlide key={`slide-${index}`}>{cardType(entry)}</SwiperSlide>
    ));

  const renderExperienceCards = () => {
    const experienceCards = externalProducts
      ? entries.concat(externalProducts)
      : entries;
    return experienceCards.map((experienceCard, index) => (
      // eslint-disable-next-line react/no-array-index-key
      <SwiperSlide key={`slide-${index}`}>
        {cardType(experienceCard)}
      </SwiperSlide>
    ));
  };

  return (
    <div className={onlyOneEntry ? 'container-xxl px-md-0' : undefined}>
      <Swiper
        slidesPerView={onlyOneEntry ? 1 : 1.3}
        slidesOffsetBefore={onlyOneEntry ? null : 16}
        slidesOffsetAfter={onlyOneEntry ? null : 16}
        spaceBetween={16}
        breakpoints={{
          768: {
            slidesPerView,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
            allowSlideNext: false,
            allowSlidePrev: false,
          },
        }}
      >
        {cardType === ExperienceCard
          ? renderExperienceCards()
          : renderEntries()}
      </Swiper>
    </div>
  );
};

export default RelatedEntriesCarousel;

const cardsCommonProps = PropTypes.shape({
  previewImage: PropTypes.shape({
    url: PropTypes.string.isRequired,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
    alt: PropTypes.string,
  }),
  type: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  previewText: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
});

RelatedEntriesCarousel.propTypes = {
  entries: PropTypes.arrayOf(
    PropTypes.shape({
      cardsCommonProps,
      type: PropTypes.string,
      fromPrice: PropTypes.bool,
      productPrice: PropTypes.number,
      productSalePrice: PropTypes.number,
      productPriceDefinition: PropTypes.string,
      badgeText: PropTypes.string,
      blogCategory: PropTypes.shape({
        title: PropTypes.string,
        url: PropTypes.string,
      }),
      dateString: PropTypes.string,
    })
  ),
  externalProducts: PropTypes.arrayOf(
    PropTypes.shape({
      cardsCommonProps,
      badgeText: PropTypes.string,
    })
  ),
};
